module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "text-xs-center pt-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "100",
      "width": "5",
      "color": "purple",
      "indeterminate": ""
    }
  })], 1) : _c('div', {
    staticClass: "px-2 pt-2",
    staticStyle: {
      "height": "100%",
      "background-color": "#ffff"
    }
  }, [_c('v-form', {
    ref: "formVoting",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validFormVoting),
      callback: function($$v) {
        _vm.validFormVoting = $$v
      },
      expression: "validFormVoting"
    }
  }, [_c('v-container', {
    attrs: {
      "align-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    staticStyle: {
      "text-align": "center!important",
      "max-height": "200px"
    },
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [(_vm.employeeSelected['imgSrc']) ? _c('div', {
    staticClass: "mt-1",
    staticStyle: {
      "width": "100%",
      "max-width": "150px",
      "height": "200px",
      "margin": "0 auto",
      "background-position": "center",
      "background-size": "cover"
    },
    style: ('background-image: url(' + _vm.employeeSelected['imgSrc'] + ');')
  }) : _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "150px",
      "height": "200px",
      "object-fit": "contain",
      "opacity": "0.6",
      "background": "#ddd"
    },
    attrs: {
      "src": "/o/opencps-store/js/kios_bng/img/avatar_contacts.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-2",
    staticStyle: {
      "word-wrap": "break-word",
      "position": "relative"
    },
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "text-bold primary--text",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.employeeSelected.fullName))]), _vm._v(" "), (_vm.employeeSelected.jobPosTitle || _vm.employeeSelected.workingUnitName) ? _c('div', {
    staticClass: "primary--text"
  }, [_vm._v("\n                  " + _vm._s(_vm.employeeSelected.jobPosTitle) + " - " + _vm._s(_vm.employeeSelected.workingUnitName) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Email: " + _vm._s(_vm.employeeSelected.email))]), _vm._v(" "), _c('div', {
    style: (_vm.isMobile ? '' : 'position:absolute;top:0;right:0')
  }, [_c('star-rating', {
    attrs: {
      "read-only": "",
      "rating": _vm.employeeSelected['score'],
      "increment": 0.1,
      "max-rating": 5,
      "show-rating": false,
      "star-size": 30,
      "title": _vm.employeeSelected['score'] + '/5*'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-bold primary--text pl-2"
  }, [_vm._v(_vm._s(_vm.employeeSelected['totalVoting']) + " lượt đánh giá")])], 1), _vm._v(" "), (!_vm.isMobile) ? _c('div', _vm._l((_vm.votingItems), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "text-bold primary--text"
    }, [_vm._v("* " + _vm._s(item.subject))]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-radio-group', {
      staticClass: "py-0",
      attrs: {
        "height": "10",
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item['choices']), function(itemChoise, indexChoise) {
      return _c('v-radio', {
        key: 'rd' + indexChoise,
        attrs: {
          "height": "10",
          "value": indexChoise + 1
        }
      }, [_c('div', {
        class: item.selected === indexChoise + 1 ? 'primary--text' : 'black--text',
        attrs: {
          "slot": "label"
        },
        slot: "label"
      }, [_vm._v(_vm._s(itemChoise))])])
    }), 1)], 1)])
  }), 0) : _vm._e()])], 1), _vm._v(" "), (_vm.isMobile) ? _c('div', _vm._l((_vm.votingItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "px-2 mt-3"
    }, [_c('div', {
      staticClass: "text-bold primary--text"
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(item.subject))]), _vm._v(" "), _c('div', {
      staticClass: "ml-3"
    }, [_c('v-radio-group', {
      attrs: {
        "height": "10",
        "row": ""
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    }, _vm._l((item['choices']), function(itemChoise, indexChoise) {
      return _c('v-radio', {
        key: 'rd' + indexChoise,
        attrs: {
          "label": itemChoise,
          "height": "10",
          "value": indexChoise + 1
        }
      })
    }), 1)], 1)])
  }), 0) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center my-3",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [(Array.isArray(_vm.votingItems) && _vm.votingItems.length > 0) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.votingDialog_hidden_loading,
      "disabled": _vm.votingDialog_hidden_loading
    },
    on: {
      "click": _vm.submitResultVoting
    }
  }, [_vm._v("\n          Gửi đánh giá\n        ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("reply")]), _vm._v(" \n          Quay lại \n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.dialogShowApplicantIdNo),
      callback: function($$v) {
        _vm.dialogShowApplicantIdNo = $$v
      },
      expression: "dialogShowApplicantIdNo"
    }
  }, [_c('v-form', {
    ref: "formVoting",
    staticClass: "dialog-submit-voting",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.validFormVoting),
      callback: function($$v) {
        _vm.validFormVoting = $$v
      },
      expression: "validFormVoting"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Nhập số CMND, mã hồ sơ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogShowApplicantIdNo = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "applicantIdNo",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "applicantIdNo"
    }
  }, [_vm._v("Số CMND/ Hộ chiếu")])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNo",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNo"
    }
  }, [_vm._v("Mã hồ sơ")])])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doVottingSubmit($event)
      }
    }
  }, [_vm._v("Đồng ý")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return (function () { return _vm.dialogShowApplicantIdNo = false; })($event)
      }
    }
  }, [_vm._v("Quay lại")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-16bb497c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16bb497c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChiTietDanhGiaCanBo.vue
// module id = 521
// module chunks = 1